import { Theme, useMediaQuery } from '@mui/material';

export const useMediaDevice = () => {
    const isMobile = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    const isMobileTablet = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('md')
    );

    return {
        isMobile,
        isTablet: isMobileTablet && !isMobile,
        isMobileTablet: isMobileTablet,
    };
};
